import { nextTick } from 'vue';
import { WORKFLOW_VARIABLE_DRAG_TYPE } from './workflowFlowVariableCatalog';

/** Permite largar variáveis do fluxo em inputs de texto / textarea (arrastar do painel lateral). */
export const workflowVariableDrop = {
  mounted(el, binding) {
    const target = el.matches('input, textarea')
      ? el
      : el.querySelector('input, textarea');
    if (!target) return;

    const opts =
      binding.value && typeof binding.value === 'object' ? binding.value : {};

    const onDragOver = e => {
      if (opts.disabled) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    };

    const onDrop = e => {
      if (opts.disabled) return;
      e.preventDefault();
      const token =
        e.dataTransfer.getData(WORKFLOW_VARIABLE_DRAG_TYPE) ||
        e.dataTransfer.getData('text/plain');
      if (!token || !String(token).trim()) return;
      if (target.disabled || target.readOnly) return;

      const prev = target.value;
      const start =
        typeof target.selectionStart === 'number'
          ? target.selectionStart
          : prev.length;
      const end =
        typeof target.selectionEnd === 'number' ? target.selectionEnd : prev.length;
      const next = `${prev.slice(0, start)}${token}${prev.slice(end)}`;
      target.value = next;

      target.dispatchEvent(new InputEvent('input', { bubbles: true }));

      nextTick(() => {
        target.focus();
        const pos = start + token.length;
        try {
          target.setSelectionRange(pos, pos);
        } catch {
          /* password ou inputs sem seleção */
        }
      });
    };

    el.__wfVarDrop_target = target;
    el.__wfVarDrop_onDragOver = onDragOver;
    el.__wfVarDrop_onDrop = onDrop;
    target.addEventListener('dragover', onDragOver);
    target.addEventListener('drop', onDrop);
  },

  unmounted(el) {
    const target = el.__wfVarDrop_target || el;
    if (el.__wfVarDrop_onDragOver) {
      target.removeEventListener('dragover', el.__wfVarDrop_onDragOver);
    }
    if (el.__wfVarDrop_onDrop) {
      target.removeEventListener('drop', el.__wfVarDrop_onDrop);
    }
    delete el.__wfVarDrop_target;
    delete el.__wfVarDrop_onDragOver;
    delete el.__wfVarDrop_onDrop;
  },
};
